// format GeoJSON LineString to LatLngLiteral for google maps
export const lineStringToLatLng = (lineStringArray) => {
    return lineStringArray.map((point) => {
        return { lng: point[0], lat: point[1] };
    });
};

// append photo count stats to each location
// Note: no longer called: LT-7369 Hides the 3 count columns for Litter, Bins and Hotspot photos on TaskGrid
export const appendPhotoStatData = (
    locationsArray,
    formattedLocations,
    allLitters,
) => {
    // TODO: There may be a bug in the counting logic used here.  Total should be sum of all litters of all Segments of the Task.
    // extract photo count stats for each location
    const photoStatPerLocationTask = locationsArray.map((locationTask) => {
        let photoStats =
            locationTask.activities &&
            locationTask.activities.reduce(
                (acc, curr) => {
                    // ensure only segments that are not rejected are counted
                    if (curr.activityStatus !== 'REJECTED') {
                        const currentId = curr.id.toString();
                        if (allLitters[currentId]) {
                            allLitters[currentId].forEach((litter) => {
                                // ensure only valid classifications are counted
                                // default remaining values to litter
                                if (
                                    ![
                                        'BAGGAGE',
                                        'COLLECTED',
                                        'SEGMENT_INTRO',
                                    ].includes(litter.classification)
                                ) {
                                    switch (litter.classification) {
                                        case 'BIN':
                                            acc.binPhotos += 1;
                                            break;

                                        case 'LITTER':
                                            acc.litterPhotos += 1;
                                            break;

                                        case 'HOTSPOT':
                                            acc.hotspotPhotos += 1;
                                            break;

                                        default:
                                            acc.litterPhotos += 1;
                                            break;
                                    }
                                }
                            });
                        }
                    }
                    return acc;
                },
                { binPhotos: 0, litterPhotos: 0, hotspotPhotos: 0 },
            );

        return {
            id: locationTask.id,
            ...photoStats,
        };
    });

    // append photo count stats to each location
    return formattedLocations.map((locationTask) => {
        let foundPhotoStat = photoStatPerLocationTask.find(
            (stat) => stat.id === locationTask.id,
        );

        return {
            ...locationTask,
            binPhotos: foundPhotoStat.binPhotos ? foundPhotoStat.binPhotos : 0,
            litterPhotos: foundPhotoStat.litterPhotos
                ? foundPhotoStat.litterPhotos
                : 0,
            hotspotPhotos: foundPhotoStat.hotspotPhotos
                ? foundPhotoStat.hotspotPhotos
                : 0,
        };
    });
};

/**
 * Count the ACCEPTED Tasks or Segments to display in the Header
 * @param {array} taskOrSegmentArray
 * @returns number of Tasks or Segments in the array with a status 'ACCEPTED'
 */
export const countAccepted = (taskOrSegmentArray) => {
    return taskOrSegmentArray.filter(
        (taskOrSegment) => taskOrSegment.status === 'ACCEPTED',
    ).length;
};

/**
 * Format Tasks into array to be used in the TaskGrid.
 * Sums the activities by status.
 */
export const formatRawTasks = (tasks) => {
    const taskData = tasks.map((t) => {
        const location = t.location;

        const submittedSegments =
            t.activities &&
            t.activities.reduce((acc, curr) => {
                if (
                    curr.activityStatus === 'COMPLETED' ||
                    curr.activityStatus === 'ACCEPTED' ||
                    curr.activityStatus === 'REJECTED'
                ) {
                    acc += 1;
                }

                return acc;
            }, 0);

        const rejectedSegments =
            t.activities &&
            t.activities.reduce((acc, curr) => {
                if (curr.activityStatus === 'REJECTED') {
                    acc += 1;
                }

                return acc;
            }, 0);

        const acceptedSegments =
            t.activities &&
            t.activities.reduce((acc, curr) => {
                if (curr.activityStatus === 'ACCEPTED') {
                    acc += 1;
                }

                return acc;
            }, 0);

        return {
            id: t.id,
            updatedAt: new Date(parseInt(t.updatedAt)).toUTCString(),
            locationName: location && location.name ? location.name : '',
            taskName: t.name,
            zone: location && location.zoneNumber ? location.zoneNumber : '',
            commentsMessage:
                t.comments && t.comments.length > 0 ? 'View Comments' : 'N/A',
            comments: t.comments ? t.comments : [],
            requiredSegments: t.taskTypeNumSegments,
            submittedSegments,
            rejectedSegments,
            acceptedSegments,
            status: t.status,
            assignedResearcher: t.assigneeFullName,
        };
    });

    return taskData;
};

/**
 * Format Tasks into Segments array to be used in the SegmentsGrid
 */
export const formatRawSegments = (tasks) => {
    const allSegments = tasks
        .filter((t) => t && t.activities)
        .map((t) => {
            return t.activities.map((activity) => {
                return {
                    ...activity,
                    taskName: t.name,
                    locationName:
                        t && t.location && t.location.name
                            ? t.location.name
                            : '',
                    taskId: t.id,
                };
            });
        })
        .flat();

    const segmentData = allSegments.map((s) => {
        return {
            id: s.id,
            taskName: s.taskName,
            locationName: s.locationName,
            segmentName: s.name,
            location:
                s.locationParsed && s.locationParsed.coordinates
                    ? lineStringToLatLng(s.locationParsed.coordinates)
                    : [],
            distance: s.distance ? s.distance : 0,
            duration: s.duration
                ? new Date(s.duration * 1000).toISOString().substring(14, 19)
                : '00:00', //format seconds as duration mm:ss
            dateCompleted: s.endTime ? new Date(s.endTime) : null,
            notesMessage: s.notes ? 'View Notes' : 'N/A',
            notes: s.notes ? s.notes : '',
            photos: 'View Photos',
            status: s.status,
            taskId: s.taskId,
        };
    });

    return segmentData;
};
